import { render, staticRenderFns } from "./archiveManage.vue?vue&type=template&id=64541f0c&scoped=true&"
import script from "./archiveManage.vue?vue&type=script&lang=js&"
export * from "./archiveManage.vue?vue&type=script&lang=js&"
import style0 from "./archiveManage.vue?vue&type=style&index=0&id=64541f0c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64541f0c",
  null
  
)

export default component.exports